// extracted by mini-css-extract-plugin
export default {"container":"Title_Ui_container__NPAyL","colored":"Title_Ui_colored__OL60G","big":"Title_Ui_big__Xdhr1"};